module.exports = __webpack_public_path__ + "static/img-duotono-0744d80ebb62a64e676115f29cd566ef.png";